import { useFetchBrokersQuery } from '@api/Trinium/Endpoints/Broker/slice';
import useCurrentTerminal from '@hooks/useCurrentTerminal';
import { DataGridPro, GridRowSelectionModel } from '@mui/x-data-grid-pro';
import { brokerCarrierColumnDefinitions, brokerMobileColumnDefinitions } from './columns';
import { useMediaQuery, useTheme } from '@mui/material';
import { GenericOverlay } from '../GenericNoRowsOverlay';
import BrokerCarrierGridToolbar from './GridToolbar';
import { applyThemeGridSxOverrides } from '@/Infrastructure/Theme/AppThemeOverrides';
import { BrokerCarrierDataGridProps } from '../types';

export default function Grid(props: BrokerCarrierDataGridProps) {
  const { number: terminalNumber } = useCurrentTerminal();
  const { data, isLoading } = useFetchBrokersQuery({
    terminalNumber,
    isActive: true
  }); // only active

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  function onSingleRowSelect(rowSelectionModel: GridRowSelectionModel) {
    if (rowSelectionModel.ids.size > 0) {
      const selectedRowId = rowSelectionModel.ids.keys().next().value;

      const selectedRow = data?.find((broker) => broker.id === selectedRowId);

      if (selectedRow) {
        /** Execute the callback */
        props.onChange({ driver: selectedRow, tractorId: null });
      }
    }
  }

  return (
    <DataGridPro
      columns={isMobile ? brokerMobileColumnDefinitions : brokerCarrierColumnDefinitions}
      rows={data ?? []}
      loading={isLoading}
      onRowSelectionModelChange={onSingleRowSelect}
      rowHeight={isMobile ? 84 : 50}
      columnHeaderHeight={35}
      slots={{
        toolbar: BrokerCarrierGridToolbar,
        noRowsOverlay: () => <GenericOverlay overlayText='No Broker Carriers Found' />,
        noResultsOverlay: () => <GenericOverlay overlayText='No Broker Carrier Results' />
      }}
      slotProps={{
        loadingOverlay: { variant: 'skeleton' }
      }}
      sx={{
        ...applyThemeGridSxOverrides(),
        '& .MuiDataGrid-columnHeaders': isMobile
          ? {
              display: 'none'
            }
          : {}
      }}
    />
  );
}
